import { axioTokens } from "../../theme";

export const DISPOSITIONS = [
  { value: "interested", label: "Interested", color: "green" },
  { value: "follow_up", label: "Follow up later", color: "blue" },
  { value: "no_answer", label: "No answer", color: "gray" },
  { value: "busy", label: "Busy", color: "yellow" },
  { value: "not_interested", label: "Not interested", color: "orange" },
  { value: "not_a_fit", label: "Not a fit", color: "red" },
  { value: "wrong_number", label: "Wrong number", color: "grape" },
] as const;

export const REJECT_REASONS = [
  { value: "communication", label: "Communication" },
  { value: "skills", label: "Skills" },
  { value: "salary", label: "Salary" },
  { value: "experience", label: "Experience" },
  { value: "location", label: "Location" },
  { value: "other", label: "Other" },
];

export const EXPLORE_QUEUE_LIMIT = 1;
export const EXPLORE_SAVE_FORWARD_LIMIT = 5;
export const MISSING_SKILLS_VISIBLE = 3;
export const EXPLORE_FACT_GRID_COLS = { base: 1, [axioTokens.containerQuery.sm]: 2, [axioTokens.containerQuery.lg]: 3 } as const;
export const EXPLORE_FACT_GRID_SPAN_ALL = "1 / -1";
export const EXPLORE_SKILL_FIT_LABEL = "Matched & missing skills";
export const EXPLORE_SKILL_UNCONFIGURED_COPY = "No job skills configured — ranking is weaker";
export const EXPLORE_SKILL_NONE_COPY = "none";
export const EXPLORE_EDUCATION_NOTES_LABEL = "Education notes";
export const EXPLORE_JOB_PICKER_PAGE_SIZE = 50;
export const CALL_SCAN_TO_DIAL_COPY = "Scan with your phone to dial";
export const CALL_ON_THIS_PHONE_LABEL = "Call on this phone";
export const CALL_CANDIDATE_LABEL = "Call";
export const CALL_COPY_NUMBER_LABEL = "Copy";
export const COPY_EMAIL_LABEL = "Copy email";
export const CALL_NUMBER_COPIED = "Copied";
export const CALL_POPOVER_CANCEL_LABEL = "Cancel";
export const POPOVER_CLOSE_OFFSET = "var(--axio-unit-6)";
export const POPOVER_CLOSE_STYLE = {
  position: "absolute",
  top: POPOVER_CLOSE_OFFSET,
  right: POPOVER_CLOSE_OFFSET,
  zIndex: axioTokens.number.one,
} as const;
export const CALL_NO_PHONE_COPY = "No phone on file";
export const CALL_COARSE_POINTER_QUERY = "(pointer: coarse)";
export const CALL_DIAL_QR_SIZE = axioTokens.unit[180];
export const CALL_DIAL_POPOVER_QR_SIZE = axioTokens.unit[120];
export const MATCH_SCORE_LABEL = "Match score";
const MS_PER_DAY = 24 * 60 * 60 * 1000;

export function daysSince(iso: string): number {
  return Math.floor((Date.now() - new Date(iso).getTime()) / MS_PER_DAY);
}

export function exploreQueueQueryKey(
  jobId: string | null,
  mustHaveOnly: boolean,
  callableOnly: boolean,
  withinBudgetOnly: boolean,
  matchingLocationsOnly: boolean,
) {
  return [
    "explore-queue",
    jobId,
    mustHaveOnly,
    callableOnly,
    withinBudgetOnly,
    matchingLocationsOnly,
    EXPLORE_QUEUE_LIMIT,
  ] as const;
}

export const SOURCING_ORIGIN_COPY = {
  axiohire: {
    label: "AxioHire-owned candidate",
    feeGoesTo: "AxioHire",
  },
  recruiter_link: {
    label: "Your candidate — registered via your link",
    feeGoesTo: "you",
  },
  jd_link: {
    label: "Your candidate — registered via the job link",
    feeGoesTo: "you",
  },
} as const;

export type SourcingOrigin = keyof typeof SOURCING_ORIGIN_COPY;

export const EXPLORE_WORK_MODE_OPTIONS = [
  { value: "remote", label: "Remote" },
  { value: "hybrid", label: "Hybrid" },
  { value: "onsite", label: "On-site" },
];

export const EXPLORE_QUEUE_WS_EVENTS = [
  "match_released_to_available",
  "match_released_to_cooldown",
  "match_owned",
  "match_follow_up",
  "match_terminal",
  "match_claimed",
] as const;
